/**
 * @Author : ShaJiaJing
 * @Date : 2019/9/5
 * @Version : 1.0
 * @Content : 录像播放
 */
import fetch from '@/utils/fetch2'

// 获取录像信息
export function getVideoInfo (jobId) {
  return fetch.get('/jobs/records', { jobId })
}

// 获取第一帧图片
export function getVideoPoster (sessionNo) {
  return fetch.get('/jobs/firstImage', { sessionNo }, { hideCode: true, responseType: 'blob' })
}
